import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "gap", "gapHorizontal", "gapVertical", "margin", "marginHorizontal", "marginLeft", "marginRight", "marginVertical"];
import React from 'react';
import { Box } from '@bubble-ui/layout-box';
import { useSpace } from '@bubble-ui/hook-use-styles';
import { DEFAULT_GAP, DEFAULT_MARGIN_HORIZONTAL } from './constants';
import { GridContext } from './GridContext';
import { GridItem } from './Item';
var GridComponent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      gap = DEFAULT_GAP,
      gapHorizontal: gapHorizontalProp = gap,
      gapVertical = gap,
      margin,
      marginHorizontal = margin,
      marginLeft: marginLeftProp = marginHorizontal,
      marginRight: marginRightProp = marginHorizontal,
      marginVertical = margin
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var gapHorizontal = useSpace(gapHorizontalProp);
  var marginLeft = useSpace(marginLeftProp !== null && marginLeftProp !== void 0 ? marginLeftProp : DEFAULT_MARGIN_HORIZONTAL);
  var marginRight = useSpace(marginRightProp !== null && marginRightProp !== void 0 ? marginRightProp : DEFAULT_MARGIN_HORIZONTAL);
  return /*#__PURE__*/React.createElement(Box, _extends({
    wrap: true,
    direction: "horizontal",
    marginLeft: marginLeft - gapHorizontal / 2,
    marginRight: marginRight - gapHorizontal / 2,
    marginVertical: marginVertical,
    gapVertical: gapVertical
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(GridContext.Provider, {
    value: {
      gapHorizontal
    }
  }, children));
});
GridComponent.displayName = 'Grid';
export var Grid = Object.assign(GridComponent, {
  // Assigning arbitrary static props to a component makes ts unhappy. Using Object.assign works, and actually semantically makes
  // sense as we're creating a compound component. See https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-894053907
  Item: GridItem
});
//# sourceMappingURL=index.js.map